import { DROPDOWN_JOB_LIST } from '../../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {},
};

export default function (state = { initialState }, { type, payload } = {}) {
  switch (type) {
    case DROPDOWN_JOB_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DROPDOWN_JOB_LIST.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case DROPDOWN_JOB_LIST.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
